import request from '../config/axiosConfig';
import { CREATE_ROLE, DELETE_ROLE, GET_LIST_ROLES, UPDATE_ROLE } from '../constants/apiEndPoint';

export const getListRolesRequest = async (data) => {
  const result = await request({
    url: GET_LIST_ROLES,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const createRoleRequest = async (data) => {
  const result = await request({
    url: CREATE_ROLE,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateRoleRequest = async (data) => {
  const result = await request({
    url: UPDATE_ROLE,
    method: 'PUT',
    data,
  });
  return result?.data;
};

export const deleteRoleRequest = async (data) => {
  const result = await request({
    url: DELETE_ROLE,
    method: 'DELETE',
    data,
  });
  return result?.data;
};
